export const resourceConfig = {
  document: {
    displayName: "Сборники",
    icon: "sli-document",
    endpoint: "document",
    populate: [{ path: "quarters" }],
    fields: [
      { name: "label", label: "Название", type: "text" },
      {
        name: "quarters",
        label: "Кварталы",
        type: "foreignKey",
        multiple: true,
        resource: "quarter",
      },
      {
        name: "constructor_expenses",
        label: "Расходы подрядчика",
        type: "number",
        hideInList: true,
      },
      {
        name: "estimated_profit_standard",
        label: "Норматив сметной прибыли",
        type: "number",
        hideInList: true,
      },
      {
        name: "commissioning_constructor_expenses",
        label: "Расходы подрядчика(пусконаладка)",
        type: "number",
        hideInList: true,
      },
      {
        name: "tariff_coefficient",
        label: "Коэффициент тарифа",
        type: "number",
        hideInList: true,
      },
      {
        name: "work_category_coefficient",
        label: "Коэффициент категории работ",
        type: "number",
        hideInList: true,
      },
      {
        name: "br", // Base rate
        label: "Базовая ставка",
        type: "number",
        hideInList: true,
      },
      {
        name: "rts", // Regulated time spent at a road construction site, %
        label:
          "Регламентированное время нахождения на объекте дорожно-строительных работ, %",
        type: "number",
        hideInList: true,
      },
      {
        name: "ste", // Standard travel expenses (daily allowance, rental of housing), MRC
        label: "Норматив командировочных расходов (суточные, найм жилья), МРП",
        type: "number",
        hideInList: true,
      },
      {
        name: "oe", // Overhead expenses, %
        label: "Накладные расходы, %",
        type: "number",
        hideInList: true,
      },
      {
        name: "le", // Laboratory expenses, %
        label: "Расходы на лабораторные исследования, %",
        type: "number",
        hideInList: true,
      },
      {
        name: "mw", // Minimum wage
        label: "Минимальная зарплата",
        type: "number",
        hideInList: true,
      },
      {
        name: "mci", // Minimum calculation indicator
        label: "Минимальный расчетный показатель",
        type: "number",
        hideInList: true,
      },
    ],
    group: "Общее",
  },
  worktype: {
    displayName: "Типы работ",
    endpoint: "worktype",
    icon: "sli-type-of-works",
    fields: [
      { name: "code", label: "Код", type: "text" },
      { name: "rank", label: "Разряд", type: "number" },
      { name: "position", label: "Подразряд", type: "number" },
    ],
    group: "Сборник цен на затраты труда",
  },
  tariff: {
    displayName: "Разряды дорожных рабочих",
    endpoint: "tariff",
    icon: "sli-wallet",
    fields: [
      { name: "rank", label: "Разряд", type: "number" },
      { name: "position", label: "Подразряд", type: "number" },
      { name: "value", label: "Тарифный коэффициент", type: "number" },
    ],
    group: "Сборник цен на затраты труда",
  },
  year: {
    displayName: "Среднемесячная норма рабочего времени",
    endpoint: "year",
    icon: "sli-year",
    fields: [
      { name: "year", label: "Год", type: "text" },
      { name: "monthsWorkingHours", label: "Часы за месяц", type: "number" },
    ],
    hideInList: true,
  },
  quarter: {
    displayName: "Среднемесячная заработная плата по данным АСПИР РК",
    endpoint: "quarter",
    icon: "sli-quarter",
    populate: [{ path: "year" }],
    fields: [
      {
        name: "year",
        label: "Год",
        type: "foreignKey",
        resource: "year",
      },
      {
        name: "quarter",
        label: "Квартал",
        type: "select",
        options: [
          { label: "I", value: 1 },
          { label: "II", value: 2 },
          { label: "III", value: 3 },
          { label: "IV", value: 4 },
        ],
      },
      {
        name: "quarterWages",
        type: "number",
        label: "Заработная плата за месяц, тенге",
      },
    ],
    hideInList: true,
  },
  region: {
    displayName: "Регионы Республики Казахстан / коэффициент эмиссии",
    endpoint: "region",
    icon: "sli-region",
    fields: [
      { name: "code", label: "Код", type: "text" },
      { name: "name", label: "Название", type: "text" },
      {
        name: "name_kk",
        label: "Название Қаз",
        type: "text",
        hideInList: true,
      },
      // { name: "sts", label: "Прошлый СТС", type: "number" },
      // { name: "sczt", label: "Прошлый СЦЗТ", type: "number" },
      {
        name: "petrol_emission",
        label: "Бензин. Ставка за 1 тонну использованного топлива, МРП",
        type: "number",
      },
      {
        name: "diesel_emission",
        label: "Дизель. Ставка за 1 тонну использованного топлива, МРП",
        type: "number",
      },
      {
        name: "zone",
        label: "Зона",
        type: "select",
        options: [
          { label: 1, value: 1 },
          { label: 2, value: 2 },
          { label: 3, value: 3 },
          { label: 4, value: 4 },
        ],
      },
    ],
    hideInList: true,
  },
  driver: {
    displayName: "Машинисты",
    endpoint: "driver",
    icon: "sli-driver",
    fields: [
      { name: "code", label: "Код", type: "text", required: true },
      { name: "rank", label: "Разряд", type: "text", required: true },
    ],
    group: "Сборник цен на затраты труда",
  },
  material: {
    displayName: "Материалы",
    endpoint: "material",
    icon: "sli-material",
    sort: "code",
    fields: [
      { name: "code", label: "Код", type: "text" },
      { name: "name_kk", label: "Название Қаз", type: "text" },
      { name: "name_ru", label: "Название Рус", type: "text" },
    ],
  },
  transport: {
    displayName: "Технические характеристики машин и механизмов",
    endpoint: "transport",
    sort: "code",
    icon: "sli-car",
    fields: [
      {
        name: "department",
        label: "Категория",
        type: "foreignKey",
        resource: "transportdepartment",
      },
      { name: "code", label: "Код", type: "text" },
      { name: "name_kk", label: "Название Қаз", type: "text" },
      { name: "name_ru", label: "Название Рус", type: "text" },
      // {
      //   name: "cost",
      //   label: "Стоимость техники без ндс в тенге",
      //   type: "number",
      // },
      // {
      //   name: "mh_year",
      //   label: "Директиная норма, маш-Час/год",
      //   type: "number",
      // },
      // {
      //   name: "mh_year_2",
      //   label: "Директиная норма, маш-Час/год 2",
      //   type: "number",
      // },
      // {
      //   name: "mh_year_3",
      //   label: "Директиная норма, маш-Час/год 3",
      //   type: "number",
      // },
      // {
      //   name: "mh_year_4",
      //   label: "Директиная норма, маш-Час/год 4",
      //   type: "number",
      // },
    ],
    hideInList: true,
  },
  workcategory: {
    displayName: "Работники инженерного звена",
    endpoint: "workcategory",
    icon: "sli-case",
    fields: [
      { name: "name", label: "Название", type: "text" },
      { name: "coefficient", label: "Коэффициент", type: "number" },
    ],
    group: "Сборник цен на затраты труда",
  },
  commissioningwork: {
    displayName: "Пусконаладочные работы",
    endpoint: "commissioningwork",
    icon: "sli-layer",
    populate: [{ path: "workCategory" }],
    fields: [
      { name: "code", label: "Код", type: "text" },
      {
        name: "workCategory",
        label: "Категория рабочих",
        type: "foreignKey",
        resource: "workcategory",
      },
    ],
    group: "Сборник цен на затраты труда",
  },
  documenttransport: {
    displayName: "Стоимость машин и механизмов",
    endpoint: "documenttransport",
    icon: "sli-box",
    populate: [{ path: "document" }, { path: "transport" }],
    fields: [
      {
        name: "document",
        label: "Проект",
        type: "foreignKey",
        resource: "document",
      },
      {
        name: "transport",
        label: "Транспорт",
        type: "foreignKey",
        resource: "transport",
      },
      {
        name: "cost",
        label: "Стоимость техники без ндс в тенге",
        type: "number",
      },
      {
        name: "mh_year",
        label: "Директиная норма, маш-Час/год",
        type: "number",
      },
      {
        name: "mh_year_2",
        label: "Директиная норма, маш-Час/год 2",
        type: "number",
      },
      {
        name: "mh_year_3",
        label: "Директиная норма, маш-Час/год 3",
        type: "number",
      },
      {
        name: "mh_year_4",
        label: "Директиная норма, маш-Час/год 4",
        type: "number",
      },
      { name: "has_rebase", label: "Есть ли перебазировка?", type: "boolean" },
      { name: "depreciation", label: "Амортиз отч в %", type: "number" },
      {
        name: "diesel_fuel",
        label: "Расход топл кг/ч Дизтопливо",
        type: "number",
      },
      { name: "petrol_fuel", label: "Расход топл л/ч? Бензин", type: "number" },
      { name: "justification", label: "Обоснование расхода", type: "number" },
      { name: "rank", label: "Разряд", type: "number" },
      { name: "crew", label: "Экипаж", type: "number" },
      { name: "hydraulic_liquid", label: "Гидрав жид", type: "number" },
      { name: "repair", label: "ТО, рем", type: "number" },
      {
        name: "diesel_fuel_emission",
        label: "Затраты на эмиссию Дизтопливо",
        type: "number",
      },
      {
        name: "petrol_fuel_emission",
        label: "Затраты на эмиссию Бензин",
        type: "number",
      },
      {
        name: "tax",
        label: "Затраты на транспортный налог в МРП",
        type: "number",
      },
    ],
    hideInList: true,
  },
  transportdepartment: {
    displayName: "Категории машин и механизмов",
    endpoint: "transportdepartment",
    sort: "code",
    icon: "sli-box",
    fields: [
      {
        name: "parent",
        label: "Родитель",
        type: "foreignKey",
        resource: "transportdepartment",
      },
      { name: "code", label: "Код", type: "text" },
      { name: "name_ru", label: "Название", type: "text" },
      { name: "name_kk", label: "Название Қаз", type: "text" },
    ],
    hideInList: true,
  },
};
